module.exports = __webpack_public_path__ + "img/my_shouye.5a292c04.svg";